__turbopack_context__.v({
  "cta": "FilteredVehicleCarousel-module__g3QtFG__cta",
  "hasBorderBottom": "FilteredVehicleCarousel-module__g3QtFG__hasBorderBottom",
  "reel": "FilteredVehicleCarousel-module__g3QtFG__reel",
  "reviews": "FilteredVehicleCarousel-module__g3QtFG__reviews",
  "titleWrapper": "FilteredVehicleCarousel-module__g3QtFG__titleWrapper",
  "wrapper": "FilteredVehicleCarousel-module__g3QtFG__wrapper",
});
